export default Object.freeze({
    default: 'default',
    full: 'full',
    'pull-right': 'pull-right',
});
